import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AreaRoutingModule } from './area-routing.module';
import { AreaComponent } from './area.component';
import { ApplicationTypeInfoModule } from 'src/app/components/controls/application-type-info/application-type-info.module';
import { LoadingSpinnerModule } from 'src/app/components/loading-spinner/loading-spinner.module';
import { RequestPurposeInfoModule } from 'src/app/components/controls/request-purpose-info/request-purpose-info.module';
import { ValidationTextModule } from 'src/app/components/validation-text/validation-text.module';

@NgModule({
  declarations: [AreaComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AreaRoutingModule,
    LoadingSpinnerModule,
    ApplicationTypeInfoModule,
    RequestPurposeInfoModule,
    ValidationTextModule,
  ],
})
export class AreaModule {}
